'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { isBlockByName } from '../../dom/index.js';
import { useBlock } from './hooks/index.js';
import { useBlockAttributes } from './hooks/useBlockAttributes.js';
import { DEFAULT_BLOCK_ELEMENT } from '../../dom/parseBlockAttributes.js';
export const ImageBlock = ({ domNode: node = DEFAULT_BLOCK_ELEMENT, children, component: Component, style, }) => {
    const { name, className, attributes } = useBlock(node);
    const blockAttributes = useBlockAttributes(node);
    const hasFigureNode = node.firstChild.name === 'figure';
    const { width, height } = attributes;
    let imgNode;
    if (hasFigureNode) {
        const figureNode = node.children[0];
        if (figureNode.children[0]) {
            imgNode = figureNode.children[0];
        }
    }
    else {
        imgNode = node.children[0];
    }
    const { src, alt, width: imgNodeWidth, height: imgNodeHeight } = imgNode.attribs;
    const imageWidth = width !== null && width !== void 0 ? width : imgNodeWidth;
    const imageHeight = height !== null && height !== void 0 ? height : imgNodeHeight;
    return (_jsx(Component, { name: name, domNode: node, className: className, src: src, alt: alt, attributes: blockAttributes, width: imageWidth ? Number(imageWidth) : undefined, height: imageHeight ? Number(imageHeight) : undefined, style: style, children: children }));
};
ImageBlock.test = (node) => {
    return isBlockByName(node, 'core/image');
};
